import dayjs from "dayjs"
import { useMemo } from "react"
import { useGraphContext } from "../GraphContext"

/*
 * returns the time of the specified "xPosition" where the xPosition is relative
 * to the left edge of the graph
 */
export function useXPositionAsTime(xPosition: number): string {
  const {
    pointsPerHour,
    graphScrollDate,
    zoom,
  } = useGraphContext()

  return useMemo(
    () => {
      if (isNaN(xPosition)) {
        return ""
      }

      const distanceFromCenter = xPosition - (zoom * pointsPerHour / 2)

      const time = dayjs(graphScrollDate)
        .add(
          distanceFromCenter / pointsPerHour,
          "hours",
        )
        .toISOString()
      return time
    },
    [
      xPosition,
      graphScrollDate,
      pointsPerHour,
      zoom,
    ],
  )
}
